import PropTypes from 'prop-types'

const CreativeLibraryPropTypes = PropTypes.shape({
  id: PropTypes.string.isRequired,
  creativeName: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  reviewStatus: PropTypes.string.isRequired,
  bizChannelType: PropTypes.string.isRequired,
  bizChannelName: PropTypes.string.isRequired,
  bizChannelMobileUrl: PropTypes.string,
  bizChannelPcUrl: PropTypes.string,
  bizChannelOperationStatus: PropTypes.string.isRequired,
  deleted: PropTypes.bool.isRequired,
  adGroupCount: PropTypes.number.isRequired,
  createdDate: PropTypes.string.isRequired,
  assetTypes: PropTypes.array.isRequired,
  talkChannelName: PropTypes.string,
  talkChannelPermalink: PropTypes.string,
  talkChannelProposalPhrase: PropTypes.string,
})
export default CreativeLibraryPropTypes
